export const GET_DEFAULT_OPTIONS = 'GET_DEFAULT_OPTIONS'
export const SAVE_FORM = 'SAVE_FORM'
export const CREATE_FORM = 'CREATE_FORM'
export const FETCH_FORMS = 'FETCH_FORMS'
export const GET_FORM_SINGLE = 'GET_FORM_SINGLE'
export const DELETE_SINGLE_FORM = 'DELETE_SINGLE_FORM'
export const CREATE_DEFAULT_OPTIONS = 'CREATE_DEFAULT_OPTIONS'
export const DELETE_SINGLE_QUESTION = 'DELETE_SINGLE_QUESTION'
export const UPDATE_FORM = 'UPDATE_FORM'
export const DUPLICATE_PUBLISHED_FORM = 'DUPLICATE_PUBLISHED_FORM'
